import { OreDivider, OreHeading, OreStack } from '@edenredespana/oreneta'
import { useTranslation } from 'react-i18next'

import { createApiBankAccountRepository } from '@/Contract/infrastructure'
import { AccountProvider } from '@/Contract/ui/context'
import { contractTranslation } from '@/Contract/ui/contractTranslation'
import { ChangeBankAccountAccessCard } from '@/Contract/ui/molecules'
import {
  ContractBillingDataForm,
  ContractBillingSummaryCard,
} from '@/Contract/ui/organisms'
import { WebTagPermissionEnum } from '@/Shared/domain'
import { PageWrapper } from '@/Shared/ui/layout'
import { navigationRoutes } from '@/Shared/ui/routers'
import { useWebTagPermissions } from '@/User/context/WebTagPermissionsProvider'
import { useUserData } from '@/User/ui/context'

export const ContractBillingDataPage = (): JSX.Element => {
  const { t } = useTranslation()
  const { hasPermission } = useWebTagPermissions()
  const { merchant } = useUserData()
  const show = hasPermission(WebTagPermissionEnum.ACTION_BILLING_DATA_CHANGE)
  return (
    <AccountProvider
      merchantId={merchant.id}
      repository={createApiBankAccountRepository()}
      origin={navigationRoutes.contractsBillingData}
    >
      <PageWrapper
        paddingSmaller
        paddingTop={8}
        style={{
          paddingRight: 40,
          paddingLeft: 40,
          minWidth: '-webkit-fill-available',
          marginRight: 0,
          marginLeft: 0,
        }}
      >
        <OreHeading as="h1" size="title-sm">
          {t(contractTranslation.billingData.pageTitle)}
        </OreHeading>
        <OreDivider space="medium" />
        <OreStack space="large" placeContent="stretch">
          <OreStack direction="row" space="large" placeContent="stretch" sameSize>
            <ContractBillingSummaryCard />
            <ChangeBankAccountAccessCard origin={navigationRoutes.contractsBillingData} />
          </OreStack>
          <ContractBillingDataForm show={show} />
        </OreStack>
      </PageWrapper>
    </AccountProvider>
  )
}
